import { Clipboard } from "ts-clipboard";
// import type {
//   game,
// } from "../../server/interfaces";
export function copy_room_id(game, room_id) {
    Clipboard.copy(`${window.location.protocol}//${window.location.host}?g=${game}&r=${room_id}`);
}
export function fix_state(state) {
    switch (state) {
        case "tie":
            return "Draw";
        case "forfeit":
            return "Opponent Left The Match";
        case "waiting":
            return "Waiting For Opponent";
        case "won":
            return "You Won";
        case "lost":
            return "You Lost";
    }
    return "";
}
